<div class="shop-cart-icon" [class.added]="added" aria-hidden="true">
	<i class="twingle-shopping-cart"></i>
	<span [innerHTML]="(itemCount === 1? 'shop.cartitem.single' : 'shop.cartitem') | translate: {price: price | number: priceFormat, count: itemCount, currency: currency}"></span>
</div>
